
import React, { useMemo, useRef, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import MaterialReactTable from 'material-react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faTrash, faDownload } from '@fortawesome/free-solid-svg-icons';
import AsyncSelect from 'react-select/async';
import SweetAlert2 from 'react-sweetalert2';
import useUtils from '../../../../utiles/useUtiles';
import Footer from '../../../components/Footer';
import SAlert from '../../shared/SAlert';
import ModalDetailsTemplate from '../../../components/template/ModalDetailsTemplate';

const RequestedTemplateList: React.FC = () => {

  const [requestedTemplateList, setRequestedTemplateList] = useState<any>( { count: 0, rows: [] } );
  const [csvTypes, setCsvTypes] = useState<any>( { count: 0, rows: [] } );
  const [loading, setLoading] = useState<boolean>( false );
  const [searchParams, setSearchParams] = useState<any>( { 
    search_text: '', 
    network_id: null,
    csv_type_id: null,
    status: '' 
  } );
  const [selectedTemplate, setSelectedTemplate] = useState<any>( null );
  const [showDeclineAlert, setShowDeclineAlert] = useState<boolean>( false );
  const [showDetails, setShowDetails] = useState<boolean>( false );
  const [pagination, setPagination] = useState<any>( {
    pageIndex: 0,
    pageSize: 10
  } );
  const { axiosRequest, baseUrl, toastInstance, loadingScreen, capitalizeFirstCharacter } = useUtils()
  const axios = axiosRequest();
  const toast = toastInstance();

  useEffect( () => {
    listRequestedTemplates();
    // fetchCsvTypes();
  }, [] );

  useEffect( () => {
    // listRequestedTemplates();
  }, [searchParams] );

  useEffect( () => {
    listRequestedTemplates();
  }, [ pagination ] );

  const csvTypeOptions = ( inputValue: string ): Promise<any[]> => {
    return new Promise<any[]>( async ( resolve ) => {
        const result: any[] = await fetchCsvTypes( inputValue );
        resolve( result );
    });
  }
    

  const listRequestedTemplates = async () => {
    setLoading( true );
    const searchString = Object.keys( searchParams )
    .filter( key => searchParams[key] )
    .map( key => `${key}=${searchParams[key]}` ).join( '&' );

		const request = await axios.get( `${baseUrl()}/bank_request_admin?page=${pagination.pageIndex}&pageSize=${pagination.pageSize}&${searchString}` );
    setLoading( false );
    const { error, data, message } = request.data;

		if ( error ) {
			toast.error( message );
		} else {
			setRequestedTemplateList( data );
		}
	};

  const confirmDecline = ( template: any ) => {
    setSelectedTemplate( template );
    setShowDeclineAlert( true );
  };

  const fetchCsvTypes = ( searchText: string ): Promise<any[]> => {
    return new Promise<any[]>( async ( resolve ) => {
        var query = 'page=0&pageSize=5';
        if ( searchText ) {
          query += `&searchText=${searchText}`;
        }

        const request = await axios.get( `${baseUrl()}/template_types?${query}` );
        const { error, result, message } = request.data;

        if ( error ) {
            toast.error( message );
            resolve( [] );
        } else {
            const data = result['rows'].map( (r: any) => ( {
                label: r.name,
                value: r.id 
            } ) );
            resolve( data );
        }
    } );
  };

  const onSearchChange = ( field: string, value: any ) => {
    setSearchParams( {
      ...searchParams,
      [field]: value
    } );
  };

  const handleDecline = async () => {
    setLoading( true );
		const request = await axios.post( `${baseUrl()}/bank_request_admin/decline/${selectedTemplate.id}` );
    setLoading( false );
    const { error, message } = request.data;
		if ( error ) {
			toast.error( message || 'Error to update the record' );
		} else {
      toast.success( message );
      listRequestedTemplates();
      setSelectedTemplate( null );
      setShowDeclineAlert( false );
		}
  };

  const downloadFile = async ( filepath: string ) => {
    const fileName = filepath.split( '/' ).pop() || '';
    const { data } = await axios.get( `${baseUrl()}/${filepath}`, { responseType: "blob" } );

    const url = URL.createObjectURL( new Blob( [data] ) );
    const link = document.createElement( 'a' );
    link.href = url;
    link.setAttribute( 'download', fileName );

    // Append to html link element page
    document.body.appendChild( link );

    // Start download
    link.click();

    // Clean up and remove the link
    link.parentNode && link.parentNode.removeChild( link );
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: 'client',
        header: 'Client',
        minSize: 80,
        maxSize: 150,
        Cell: ( { cell }: any ) => <span>
          {cell.getValue()['firstName'] + ' ' +cell.getValue()['lastName']}
          <p>({ cell.getValue()['email'] })</p>
          </span>,
      },{
        accessorKey: 'csv_types',
        header: 'CSV type',
        minSize: 80,
        maxSize: 150,
        Cell: ( { cell } ) => <span>{cell.getValue().name}</span>,
      },
      {
        accessorKey: 'networks',
        header: 'Network Name',
        minSize: 80,
        maxSize: 150,
        Cell: ( { cell } ) => <span>{cell.getValue().name}</span>,
      },
      {
        accessorKey: 'branch',
        header: 'Branch Name',
        minSize: 30,
        maxSize: 50,
        Cell: ( { cell } ) => <span>{cell.getValue().branchName}</span>,
      },
      {
        accessorKey: 'status',
        header: 'Status',
        minSize: 30,
        maxSize: 50,
        Cell: ( { cell } ) => <span className={ cell.getValue() == 'pending' ? 'text-danger' : ''} >{
          capitalizeFirstCharacter( cell.getValue() )
        }</span>,
      },
      {
        accessorKey: 'original_name',
        header: 'CSV File',
        minSize: 10,
        maxSize: 20,
        Cell: ( { cell } ) => <div>
            {
              cell.getValue() && (
                <span>
                    {cell.getValue()}
                    <FontAwesomeIcon
                      title='Download'
                      icon={faDownload}
                      className="isPointer ml-2 text-danger cursor-pointer"
                      onClick={() => {
                        downloadFile( cell.row.original['path'] );
                      }}
                  />
                </span>
              ) || ''
            }
        </div>,
      },
      {
        accessorKey: 'action',
        header: 'Action',
        minSize: 5,
        maxSize: 10,
        Cell: ( { cell } ) => <div>
            {
              cell.row.original['status'] == 'pending' && (
                <FontAwesomeIcon
                  title='Decline'
                  icon={faBan}
                  className="isPointer ml-2 text-danger cursor-pointer"
                  onClick={() => confirmDecline( cell.row.original )}
                />
              ) || ''
            }
        </div>,
      }
    ],
    [],
  );

  return (
    <>
        <div className="container-fluid">
            <div className="row">
                <div className="col-sm-12">
                    <div className="main-container">
                      <div className="main-container-inner">
                        <div className="main-card revrex-data-table-card">
                            <div className='d-flex justify-content-between align-items-center mb-3'>
                                <h1 className='page-title-sm'>Requested Templates</h1>
                                {/* <Link to="/" className="btn btn-md btn-custom-secondary">Add</Link> */}
                                {/* <button type='button' className='btn btn-md btn-custom-secondary' onClick={() => setShowAddUserModal(true)}> Add </button> */}
                            </div>
                            <div className='mb-4 d-flex gap-10'>
                                <div className='flex-grow-1'>
                                  <input type={"text"} name="search_text" placeholder="Client Name" className="form-control" autoComplete='new-password' onChange={( e ) => onSearchChange( 'search_text', e.target.value )} />
                                </div>
                                <div className='flex-grow-1 select-dropdown'>
                                  <AsyncSelect 
                                      placeholder="Select CSV Type"
                                      cacheOptions 
                                      isClearable={true}
                                      loadOptions={csvTypeOptions} 
                                      defaultOptions 
                                      name="csv_type_id" 
                                      onChange={selectedOption => {
                                          if ( selectedOption && selectedOption['value'] ) {
                                            onSearchChange( 'csv_type_id', selectedOption['value'] );
                                          } else {
                                            onSearchChange( 'csv_type_id', null );
                                          }
                                      }} 
                                  />
                                </div>
                                <div className='flex-grow-1 select-dropdown'>
                                  <select name="status" onChange={e => onSearchChange( 'status', e.target.value )} className='form-control'>
                                    <option value="">Select Status</option>
                                    <option value="pending">Pending</option>
                                    <option value="approved">Approved</option>
                                    <option value="rejected">Rejected</option>
                                  </select>
                                </div>
                                <div className=''>
                                  <button type="button" className="btn btn-md btn-custom-secondary" onClick={listRequestedTemplates}>Search</button>
                                </div>
                            </div>
                            
                            <div className='template-list-table'>
                                <MaterialReactTable 
                                    columns={columns} 
                                    data={requestedTemplateList?.rows} 
                                    rowCount={requestedTemplateList?.count} 
                                    enableColumnOrdering={false} 
                                    enableRowSelection={false} 
                                    enableSelectAll={false}
                                    enableColumnActions={false}
                                    manualPagination
                                    onPaginationChange={setPagination}
                                    state={{ pagination }}
                                    enableSorting={false}
                                    enableGlobalFilter={true}
                                    enableFullScreenToggle={false}
                                    enableDensityToggle={false}
                                    enableHiding={false}
                                    enableColumnFilters
                                    enableFilters={false}
                                />
                            </div>
                            
                        </div>
                      </div>
                      <Footer />
                    </div>
                </div>
            </div>
            <SAlert
              show={showDeclineAlert}
              showCancel
              confirmBtnText="Yes"
              cancelBtnText="No"
              confirmBtnBsStyle="primary"
              cancelBtnBsStyle="secondary"
              onCancel={() => setShowDeclineAlert( false )}
              title={`Are you sure to decline the record?`}
              onConfirm={() => handleDecline()}
            />
            {loadingScreen( loading )}
        </div>
    </>
  );
}

export default RequestedTemplateList